import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";

import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import moment from "moment";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import useSearchFunction from "../../../Component/searchFunction";

const TableInventory = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);

  const role = localStorage.getItem("role");
  const debounceval = useSearchFunction(searchValue);

  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);
    setSelected(selected);

    let payload = {
      search: search,
      // page: page,
      region_id: selected?.value,
      type: 2,
      // current_status: 4,
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };

    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status == "success") {
      let array = role == "Inventory" ? [4, 8] : [6]; //8 is removed by ashta
      console.log("array", array);
      let arr = res?.lists.filter((item) =>
        array.includes(item?.current_status)
      );
      let mappedData = arr.map((item) => {
        let obj = { ...item };
        obj.trackin_id = [...item?.ticket_details]
          ?.reverse()
          ?.find((i) => i.tracking)?.tracking?.tracking_no;
        return obj;
      });
      console.log("mappedData", mappedData);
      setList(mappedData);
      // setPage(res?.pagination_meta?.current_page);
      setPagination(res?.pagination_meta);
    }
  };

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval]);

  let admin_id = JSON.parse(localStorage.getItem("admin_id"));

  console.log(admin_id, "admin_id");
  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer ID",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.code}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer.name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Created by",
        accessor: "created_by.name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>
          );
        },
      },
      // {
      //   Header: role == "Inventory" ? "Tracking ID" : "Fault Type",
      //   accessor: role == "Inventory" ? "trackingid" : "fault_type",
      //   Cell: ({ value, row }) => {
      //     return (
      //       <div className="d-flex ac-jc">
      //         <button
      //           className={`${value == 4 ? "yet_to_start_btn" : value == 9 ? "dispatched_btn" : value == 10 ? "delivered_btn" : "dispatched_btn"} f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
      //         >
      //           {value == 4 ? "Yet to start" : value == 9 ? "Dispatched" : value == 10 ? "Delivered" : "-"}
      //         </button>
      //       </div>
      //     )
      //   },
      // },
      {
        Header: "Request Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <button
                // onClick={() => handleStatus(row)}
                className="Yet_To_Start     f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16"
                style={{ backgroundColor: "#323691" }}
              >
                Yet To Start
              </button>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          const assigned_id =
            row.original?.ticket_details[
              row.original?.ticket_details?.length - 1
            ]?.assigned_to?.id;

          console.log("value", assigned_id);
          return (
            <div className="d-flex ac-js mt-2 gap-3">
              <button
                onClick={() => {
                  navigate("/view-inventory", {
                    state: {
                      type: "view",
                      id: row?.original?.id,
                      tickType: "Yet",
                    },
                  });
                }}
                className="cust-btn "
              >
                <img src={view} alt="" className="editor-btn" />
              </button>

              {assigned_id == admin_id && (
                <button
                  onClick={() => {
                    navigate("/view-inventory", {
                      state: {
                        type: "edit",
                        id: row?.original?.id,
                        tickType: "Yet",
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className="editor-btn" />
                </button>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  // console.log("selected", selected);
  return (
    <>
      <Topbar header={"Yet To Start"} subHead={"Yet To Start"} />
      <div className="container_fluit1">
        <div className="d-flex ac-js">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total New Ticket :{list?.length}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <DateRange
            fromDate={fromDates}
            setFromDate={(val) =>
              ticketList(searchValue, selected, val, toDates)
            }
            toDate={toDates}
            setToDate={(val) =>
              ticketList(searchValue, selected, fromDates, val)
            }
          />
          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) =>
                ticketList(searchValue, val, fromDates, toDates)
              }
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              //  onChange={(e) => ticketList(e.target.value, selected)}
              onChange={(val) =>
                setSearchValue(val.target.value, selected, fromDates, toDates)
              }
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          // pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default TableInventory;
